module.exports = __webpack_public_path__ + "img/endowus.63677c4f.webp";